module.exports = __webpack_public_path__ + "img/SimpleExamModels.c74a9ee8.svg";